export const Routing = {
  /* Common Routes */
  Secure: '',
  List: 'list',
  Add: 'add',
  Details: 'details',
  GroupDetails: 'group-details',
  DocumentViewer: 'document-viewer',
  PrintTemplate: 'print-document',
  /* Auth Routes */
  Auth: 'auth',
  Forbidden: 'forbidden',
  Login: 'login',
  ForgotPassword: 'forgot-password',
  ResetPassword: 'reset-password',
  /* Dashboard Routes */
  Dashboard: 'dashboard',
  /* Profile Routes */
  Profile: 'profile',
  /* notification-routes */
  Notification: 'notification',
  /* Task Routes */
  Task: 'tasks',

  /* Patient Routes */
  Patient: 'patients',
  KeyDetails: 'key-details',
  VisitNote: 'visit-note',
  InvestigationResult: 'investigation-result',
  Referrals: 'referral',

  Records: 'records',
  Invoices: 'invoices',
  Appointments: 'appointments',
  CommunicationHistory: 'communication-history',
  Documents: 'documents',
  Others: 'others',

  /* Others tab Routes */
  Insurance: 'insurance',

  Correspondence: 'correspondence',
  Allergies: 'allergies',
  Vitals: 'vitals',
  Injections: 'injections',
  Vaccines: 'vaccines',
  Alerts: 'alerts',
  InvestigationOrder: 'investigation-order',
  ExercisePlans: 'exercise-plans',
  NutritionPlan: 'nutrition-plan',

  /* Admin Routes */
  Admin: 'admin',
  User: 'users',
  UserPermission: 'user-permission',
  Practitioner: 'practitioners',
  Role: 'roles',
  Location: 'locations',
  Master: 'master',
  Template: 'template',
  Log: 'log',
  Rating: 'ratings',
  /* Calendar Routes */
  Calendar: 'calendar',
  CalendarList: 'calendar-list',
  Appointment: 'appointment',

  /* Invoice Routes */
  Invoice: 'invoice',

  /* Professional Routes */
  Professional: 'professionals',

  /* Patient Education Routes */
  PatientEducation: 'patient-education',

  /* Report Routes */
  Report: 'report',

  /* Message Routes */
  Message: 'messages',
  InboxMessage: 'inbox-messages',
  OutboxMessage: 'outbox-messages',
  Broadcast: 'broadcast',
  /* Setting Routes */
  Setting: 'setting',

  /* Master Routes */
  General: 'general',
  InvoiceItem: 'invoice-item',
  PatientIdentityType: 'identity-type',
  Diagnosis: 'diagnosis',
  Language: 'language',
  TagMaster: 'tag-master',
  Pharmacies: 'pharmacies',
  AppointmentType : 'appointment-type',
  FamilyMember : 'family-member',
  CarePlan : 'care-plan',
  Equipment: 'equipments',
  Rooms: 'rooms',
  CarePlanTypes: 'careplan-types',
  TaskCategory: 'task-category',
  ReviewCategory: 'review-category',  
  PatientEducationCategories: 'patient-education-categories',
  LegalDocuments: 'legal-documents',

  Prescription: 'prescription',
  Medicine: 'medicine',
  DoseUnit: 'dose-unit',
  Frequency: 'frequency',
  Food: 'food',

  InjectionVaccination: 'injection-vaccination',
  VaccineSite: 'vaccine-site',
  VaccineRoute: 'vaccine-route',
  VaccineDoseUnit: 'vaccine-dose-unit',

  LabImage: 'lab-image',
  Centers: 'centers',
  Tests: 'tests',

  MasterPractitioner: 'practitioner',
  Qualification: 'qualification',
  Profession: 'profession',
  Expertise: 'expertise',

  /* Template Routes */
  Reports: 'reports',
  Questionnaire: 'questionnaire',
  SMS: 'sms',
  Email: 'email',
  LetterHead: 'letter-head',
  PushNotification: 'push-notification',

  /* Logs Routes */
  UserLogins: 'user-logins',
  PatientLogins: 'patient-logins',
  Credential: 'credential',
  Error: 'error',
  Action: 'action',

  /* Routing Actions */
  Manage: 'manage',
};
